import { DatadogLoggerConfigType, URLsType } from './types';

export const appVersion = '6.9.8';

export const urls: URLsType = {
    cargosprintTermsOfUse: 'https://cargosprint.com/legal/terms-of-use/#sprintpay',
    privacyAndPolicy: 'https://cargosprint.com/legal/privacy-policy',
    administrativeLogin: 'https://sprintpay.cargosprint.com/login',
};

export const googleMapIdDark: string = '8a0666dd3aa7fc77';

export const googleMapIdLight: string = 'c9061c14b9b9c68f';

export const vendorId: number = 282385;

export const statsig = {
    statsigSdkKey: '__STATSIG_SDK_KEY__',
    maintenance: {
        gateName: 'maintenance_mode',
        dynamicConfigName: 'maintenance_mode_config',
    },
};

export const datadog: DatadogLoggerConfigType = {
    enabled: true,
    applicationId: 'b8b14f7d-7661-44f5-bda2-81c65036de12',
    site: 'us5.datadoghq.com',
    clientToken: 'pub3671e32e4a20dd62380f8d42360ef9f4',
    logger: {
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
    },
    rum: {
        sessionSampleRate: 1,
        sessionReplaySampleRate: 0,
        trackResources: true,
        trackUserInteractions: true,
        trackLongTasks: true,
    },
};

export const commonEnv = {
    production: false,
    environment: 'staging',
    gotobotKey: '',
    googleMapApiKey: '__GOOGLE_MAPS_API_KEY__',
    addressValidationApiKey: '__GOOGLE_ADDRESS_VALIDATION_API_KEY__',
    projects: {
        sprintPay: 'https://uat.sprintpay.cargosprint.com',
    },
    authenticationURL: 'https://auth-staging.cargosprintgroup.com',
    cartURL: 'https://cart-staging.cargosprintgroup.com',
    invoicesURL: 'https://invoices-staging.cargosprintgroup.com',
    appSentryDsn: '',
    urls,
    googleMapIdDark,
    googleMapIdLight,
    vendorId,
    appVersion,
    enableSentry: false,
    cryptoKey: 'csspffe',
    ...statsig,
    kioskFirebaseFunctions: 'https://us-central1-testkiosk-ed7b2.cloudfunctions.net',
    keycloakConfig: {
        url: 'https://sso-uat.cargosprint.com',
        realm: 'unified-portal',
        clientId: 'sprintpay-client',
    },
    datadog,
};
